<template>
    <div>
        <v-row class="px-2 pt-2">

            <!-- From Date -->
            <v-col md="2" class="py-1">
                <v-menu
                    v-model="fromDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                ><template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="fromDate"
                        label="From Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="mt-0 pt-0"
                    ></v-text-field
                ></template>
                    <v-date-picker
                        v-model="fromDate"
                        @input="fromDateModal = false"
                        @click:date="handleDateFilters"
                    ></v-date-picker>
                </v-menu>
            </v-col>

            <!-- To Date -->
            <v-col md="2" class="py-1">
                <v-menu
                    v-model="toDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                ><template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="toDate"
                        label="To Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="mt-0 pt-0"
                    ></v-text-field
                ></template>
                    <v-date-picker
                        v-model="toDate"
                        @input="toDateModal = false"
                        @click:date="handleDateFilters"
                    ></v-date-picker>
                </v-menu>
            </v-col>

            <v-col align="end" class="py-2">
                <v-btn
                    small
                    dark
                    color="primary"
                    class="mb-3"
                    @click="download"
                    ><v-icon>mdi-arrow-down-bold</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <v-row class="px-4">
            <v-col md="12" class="pa-2">
                <v-data-table
                    v-if="report"
                    :headers="headers"
                    :items="report"
                    :items-per-page="15"
                    class="elevation-0"
                    dense
                >
                    <template v-slot:item.date>
                        {{ fromDate }} - {{ toDate }}
                    </template>
                    <template v-slot:item.cbkAmount="{ item }">
                        {{ new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(item.cbkAmount) }}
                    </template>
                    <template v-slot:item.transactions="{ item }">
                        {{ new Intl.NumberFormat('en-US').format(item.transactions) }}
                    </template>
                    <template v-slot:item.totalDebit="{ item }">
                        {{ new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(item.totalDebit) }}
                    </template>
                    <template v-slot:item.cbkRatio="{ item }">
                        <v-chip v-if="item.cbkRatio > 10" dark x-small class="error">{{ item.cbkRatio }}%</v-chip>
                        <span v-else-if="item.cbkRatio != 'N/A'">{{ item.cbkRatio }}%</span>
                    </template>
                    <template v-slot:item.cbkAmtRatio="{ item }">
                        <v-chip v-if="item.cbkAmtRatio > 10" dark x-small class="error">{{ item.cbkAmtRatio }}%</v-chip>
                        <span v-else-if="item.cbkAmtRatio != 'N/A'">{{ item.cbkAmtRatio }}%</span>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';

export default {
    data() {
        return {
            acquirer: null,
            fromDateModal: null,
            toDateModal: null,
            fromDate: moment().startOf('month').format('YYYY-MM-DD'),
            toDate: moment().format('YYYY-MM-DD'),
            loading: true,
            report: null,
            headers: [{ text: 'Merchant', value: 'merchantName', sortable: false },
                      { text: 'Acquirer', value: 'clearingInstitute', sortable: false, align: "left" },
                      { text: 'MID', value: 'merchant_id', sortable: false, align: "left" },
                      { text: 'Chargebacks', value: 'cbks', sortable: false, align: "center" },
                      { text: 'Total Chargebacks Amount', value: 'cbkAmount', sortable: false, align: "center" },
                      { text: 'Total Transactions', value: 'transactions', sortable: false, align: "center" },
                      { text: 'Total Debit', value: 'totalDebit', sortable: false, align: "center" },
                      { text: 'Chargeback %', value: 'cbkRatio', sortable: false, align: "center" },
                      { text: 'Chargeback Amount %', value: 'cbkAmtRatio', sortable: false, align: "center" }]
        }
    },
    beforeMount() {
        this.getReport();
    },
    methods: {
        getReport() {
            axios({
            method: 'post',
            url: `chargeback-stats`,
            data: { from: this.fromDate,
                    to: this.toDate },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.report = response.data;
                this.loading = false;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        handleDateFilters() {
            if(this.toDate < this.fromDate) {
                this.fromDate = this.toDate;
            }
            this.getReport();
        },
        download() {
            axios({
                method: 'post',
                url: 'download-chargeback-stats',  
                data: { from: this.fromDate,
                        to: this.toDate },            
                responseType: 'blob',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'chargeback-stats.csv');
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(e => {
                    this.errors.push(e)
            })
        }
    }
}
</script>

<style>

</style>